type ConvertToLocaleParams = {
  amount: number
  currency_code?: string
  minimumFractionDigits?: number
  maximumFractionDigits?: number
  locale?: string
}

export const convertToLocale = ({
  amount,
}: ConvertToLocaleParams) => {
  const num = Math.round(Number(amount) || 0)
  // Format: Rp with space after, thousands separator '.' e.g. Rp 359.900
  return `Rp ${num.toLocaleString("id-ID")}`
}
